import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_23c71ce2 from 'nuxt_plugin_plugin_23c71ce2' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_76cfd4bf from 'nuxt_plugin_plugin_76cfd4bf' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_libplugin335a2b95_40284f1e from 'nuxt_plugin_libplugin335a2b95_40284f1e' // Source: ./lib.plugin.335a2b95.js (mode: 'all')
import nuxt_plugin_pluginsschemas04504302_0501ece9 from 'nuxt_plugin_pluginsschemas04504302_0501ece9' // Source: ./plugins.schemas.04504302.js (mode: 'all')
import nuxt_plugin_pluginsaddstores524093df_1723c778 from 'nuxt_plugin_pluginsaddstores524093df_1723c778' // Source: ./plugins.add-stores.524093df.js (mode: 'all')
import nuxt_plugin_moment_23ac89da from 'nuxt_plugin_moment_23ac89da' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_workbox_dbd109fe from 'nuxt_plugin_workbox_dbd109fe' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_7beb9dd8 from 'nuxt_plugin_metaplugin_7beb9dd8' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_axios_54ad89b6 from 'nuxt_plugin_axios_54ad89b6' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gsapModule_20ed814c from 'nuxt_plugin_gsapModule_20ed814c' // Source: ./gsapModule.js (mode: 'all')
import nuxt_plugin_global_f21f4e84 from 'nuxt_plugin_global_f21f4e84' // Source: ../plugins/global.js (mode: 'client')
import nuxt_plugin_schemas_6fac3dbb from 'nuxt_plugin_schemas_6fac3dbb' // Source: ../plugins/schemas.js (mode: 'client')
import nuxt_plugin_repository_2cb156b7 from 'nuxt_plugin_repository_2cb156b7' // Source: ../plugins/repository.js (mode: 'client')
import nuxt_plugin_vueparticles_5824b087 from 'nuxt_plugin_vueparticles_5824b087' // Source: ../plugins/vue-particles.js (mode: 'client')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ../plugins/filters.js (mode: 'client')
import nuxt_plugin_helpers_1c816d70 from 'nuxt_plugin_helpers_1c816d70' // Source: ../plugins/helpers.js (mode: 'client')
import nuxt_plugin_localStorage_830ec59e from 'nuxt_plugin_localStorage_830ec59e' // Source: ../plugins/localStorage.js (mode: 'client')
import nuxt_plugin_nuxtquillplugin_6eadee8e from 'nuxt_plugin_nuxtquillplugin_6eadee8e' // Source: ../plugins/nuxt-quill-plugin (mode: 'all')
import nuxt_plugin_plugin_b7c2cebe from 'nuxt_plugin_plugin_b7c2cebe' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_repository_988a611a from 'nuxt_plugin_repository_988a611a' // Source: ../modules/lms/plugins/repository.js (mode: 'all')
import nuxt_plugin_lms_000d9942 from 'nuxt_plugin_lms_000d9942' // Source: ../modules/lms/plugins/lms.js (mode: 'all')
import nuxt_plugin_vuedraggable_3b9ca76b from 'nuxt_plugin_vuedraggable_3b9ca76b' // Source: ../modules/lms/plugins/vue-draggable.js (mode: 'all')
import nuxt_plugin_vuehtml2pdf_f00313aa from 'nuxt_plugin_vuehtml2pdf_f00313aa' // Source: ../modules/lms/plugins/vue-html2pdf.js (mode: 'all')
import nuxt_plugin_vueshortkey_a5caef1a from 'nuxt_plugin_vueshortkey_a5caef1a' // Source: ../modules/lms/plugins/vue-shortkey.js (mode: 'all')
import nuxt_plugin_localStorage_adf25226 from 'nuxt_plugin_localStorage_adf25226' // Source: ../modules/lms/plugins/localStorage.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s | Inspire Action for Social Change","title":"Inspire Action for Social Change","link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.png"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:300,400,500,700|Material+Icons"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"noscript":[{"innerHTML":"This website requires JavaScript."}],"meta":[],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_23c71ce2 === 'function') {
    await nuxt_plugin_plugin_23c71ce2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_76cfd4bf === 'function') {
    await nuxt_plugin_plugin_76cfd4bf(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin335a2b95_40284f1e === 'function') {
    await nuxt_plugin_libplugin335a2b95_40284f1e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsschemas04504302_0501ece9 === 'function') {
    await nuxt_plugin_pluginsschemas04504302_0501ece9(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsaddstores524093df_1723c778 === 'function') {
    await nuxt_plugin_pluginsaddstores524093df_1723c778(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_23ac89da === 'function') {
    await nuxt_plugin_moment_23ac89da(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_dbd109fe === 'function') {
    await nuxt_plugin_workbox_dbd109fe(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_7beb9dd8 === 'function') {
    await nuxt_plugin_metaplugin_7beb9dd8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_54ad89b6 === 'function') {
    await nuxt_plugin_axios_54ad89b6(app.context, inject)
  }

  if (typeof nuxt_plugin_gsapModule_20ed814c === 'function') {
    await nuxt_plugin_gsapModule_20ed814c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_global_f21f4e84 === 'function') {
    await nuxt_plugin_global_f21f4e84(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_schemas_6fac3dbb === 'function') {
    await nuxt_plugin_schemas_6fac3dbb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_repository_2cb156b7 === 'function') {
    await nuxt_plugin_repository_2cb156b7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueparticles_5824b087 === 'function') {
    await nuxt_plugin_vueparticles_5824b087(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_helpers_1c816d70 === 'function') {
    await nuxt_plugin_helpers_1c816d70(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localStorage_830ec59e === 'function') {
    await nuxt_plugin_localStorage_830ec59e(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtquillplugin_6eadee8e === 'function') {
    await nuxt_plugin_nuxtquillplugin_6eadee8e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_b7c2cebe === 'function') {
    await nuxt_plugin_plugin_b7c2cebe(app.context, inject)
  }

  if (typeof nuxt_plugin_repository_988a611a === 'function') {
    await nuxt_plugin_repository_988a611a(app.context, inject)
  }

  if (typeof nuxt_plugin_lms_000d9942 === 'function') {
    await nuxt_plugin_lms_000d9942(app.context, inject)
  }

  if (typeof nuxt_plugin_vuedraggable_3b9ca76b === 'function') {
    await nuxt_plugin_vuedraggable_3b9ca76b(app.context, inject)
  }

  if (typeof nuxt_plugin_vuehtml2pdf_f00313aa === 'function') {
    await nuxt_plugin_vuehtml2pdf_f00313aa(app.context, inject)
  }

  if (typeof nuxt_plugin_vueshortkey_a5caef1a === 'function') {
    await nuxt_plugin_vueshortkey_a5caef1a(app.context, inject)
  }

  if (typeof nuxt_plugin_localStorage_adf25226 === 'function') {
    await nuxt_plugin_localStorage_adf25226(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
